<div class="login-main-wrapper min-image-handel m-0 p-4">
  <div class="left-side">
    <div class="logo ">
      <img src="assets/images/img/logo-main.png" alt="logo">
    </div>
    <div class="inner-wrapper min-image-handel-card">
      <div class="right-content w-100  p-3 p-lg-0">
        <h1 class="fs-36 fw-600 m-0 mb-2 d-flex">
          Create New Password
        </h1>
        <p class=" mb-3 fs-16 fw-400">Set a new password to secure your account</p>
        <form class="w-100 example-form" [formGroup]="newPasswordForm" (submit)="submitForm()">
          <div class="position-relative">
            <div class="input-relative position-relative">

              <!-- <div class="position-relative input-relative"> -->
              <input [type]="!hideNewPassword ? 'password' : 'text'" class=" w-100" name="password"
                formControlName="newPassword" autocomplete="off" required maxlength="75" (focus)="showPassTooltip = true" (blur)="showPassTooltip = false" />
              <!-- </div> -->
              <label for="text" class=" fs-14 w-100">
                Password
              </label>
              <img [src]="hideNewPassword ? 'assets/images/icons/open-eye.svg' : 'assets/images/icons/close-eye.svg'"
                alt="" class="position-absolute eye-icon cursor" (click)="hideNewPassword = !hideNewPassword">
            </div>
            <span style="
                                        width: 100%;
                                        max-width: 280px;
                                        box-shadow: 3px 3px 11px #000;
                                    " class="position-absolute d-block bg-white px-3 py-3 mnw-300 info-tooltip border-tooltip radius-16"
                                            *ngIf="showPassTooltip">
                                            <p style="padding: 0 0 0 12px !important;margin-bottom: 0px; font-size: 16px;"
                                            class="m-0 fs-12 fw-800 fs-12 m-0 p-0">
                                            <!-- {{!passwordStrength || passwordStrength === 'Empty'? 'Password Strength Indication' : passwordStrength}} -->
                                            Password must contain
                                        </p>
                                            <div class="d-flex align-items-center justify-content-between my-2"
                                                style="padding-left: 10px;">
                                                <!-- <ng-container *ngFor="let item of [].constructor(4); let i = index">
                                                    <span class="w-52 mx-1"
                                                        [ngClass]="((i < totalStrength) && ((totalStrength === 1)) ? 'border-orange' : (((i < totalStrength) && (totalStrength === 2))? 'border-orange' : (((i < totalStrength) && (totalStrength === 3))? 'border-green' : (((i < totalStrength) && (totalStrength === 4))? 'border-green' : 'border-top'))))">
                                                    </span>
                                                </ng-container> -->
                                            </div>
                                            <ul class="tooltip-list" style="text-align: left;font-size: 14px;">
                                                <p class="fs-14 color-22 m-0 pb-1">It’s better to have:</p>
                                                <li style="display: flex;align-items: center;"
                                                [ngClass]="{'text-decoration-line-through color-167': hasMaxChar}"
                                                class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                    style="display: flex;justify-content: center;align-items: center;"
                                                    class="hw-16"
                                                    [ngClass]="{'p-1 bg-blue-206': hasMaxChar}"><img
                                                        [src]="hasMaxChar ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                        alt=""></span>Atleast 8 characters</li>
                                                <li style="display: flex;align-items: center;"
                                                    [ngClass]="{'text-decoration-line-through color-167': hasUpperCase}"
                                                    class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                        style="display: flex;justify-content: center;align-items: center;"
                                                        class="hw-16"
                                                        [ngClass]="{'p-1 bg-blue-206': hasUpperCase}"><img
                                                            [src]="hasUpperCase ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                            alt=""></span>Mix upper & lowercase letters</li>
                                                <li style="display: flex;align-items: center;"
                                                [ngClass]="{'text-decoration-line-through color-167': hasSpecialChar}"
                                                    class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                        style="display: flex;justify-content: center;align-items: center;"
                                                        class="hw-16"
                                                        [ngClass]="{'p-1 bg-blue-206': hasSpecialChar}"><img
                                                            [src]="hasSpecialChar ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                            alt=""></span> Add a special characters (like !&#64;#$).</li>
                                                <li style="display: flex;align-items: center;"
                                                    [ngClass]="{'text-decoration-line-through color-167': hasNumber}"
                                                    class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                        style="display: flex;justify-content: center;align-items: center;"
                                                        class="hw-16"
                                                        [ngClass]="{'p-1 bg-blue-206': hasNumber}"><img
                                                            [src]="hasNumber ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                            alt=""></span>Include a number (0-9)</li>
                                               
                                            </ul>
                                        </span>
          </div>
          <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
            *ngIf="newPasswordForm.controls['newPassword'].touched && newPasswordForm.controls['newPassword'].invalid && !newPasswordForm.controls['newPassword'].dirty">
            Please valid enter password.
          </p>
          <div class="position-relative input-relative mt-3">
            <input [type]="!hideConfirmPassword? 'password' : 'text'" class=" w-100" name="password"
              formControlName="confirmPassword" autocomplete="off" required maxlength="75" />
            <!-- </div> -->
            <label for="text" class="fs-14 w-100"> Retype password</label>
            <img [src]="hideConfirmPassword ? 'assets/images/icons/open-eye.svg' : 'assets/images/icons/close-eye.svg'"
              alt="" class="position-absolute eye-icon cursor" (click)="hideConfirmPassword = !hideConfirmPassword">
          </div>
          <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
            *ngIf="(newPasswordForm.controls['confirmPassword'].touched && newPasswordForm.controls['confirmPassword'].invalid && !newPasswordForm.controls['confirmPassword'].dirty) || (newPasswordForm.errors && newPasswordForm.errors['noMatch'] && newPasswordForm.controls['confirmPassword'].touched )">
            {{ newPasswordForm.errors && newPasswordForm.errors['noMatch'] &&
            newPasswordForm.value['confirmPassword'].length > 0 ? "Passwords did not match." : 'Please enter a
            valid password.'}}
          </p>
          <p class="mat-error text-danger w-100 d-block fs-14" *ngIf="newPasswordForm.hasError('credentialsMismatch')">
            <!-- {{data.original_text}} -->
            {{this.errorMessage}}
          </p>
          <button button-primary-auth type="submit" class="w-100 border-0 mt-3 mb-3 btn btn-primary fs-18 fw-500 "
            [disabled]="(newPasswordForm.invalid) || (newPasswordForm.errors && newPasswordForm.errors['noMatch'])">
            Change Password
          </button>
          <button (click)="routeBack()"  class="fw-500 fs-18 btn btn-default w-100">
            Back to Sign In
          </button>
        </form>
      </div>
    </div>
    <div class="align-items-center d-flex flex-wrap justify-content-between terms-condition-wrap gap-2">
      <div class="left">
        <p class="fs-14 fw-300 mb-0">
          ©{{_shared.epoch}} Recuvery LLC. All rights reserved.
        </p>
      </div>
      <div class="right">
        <ul class="d-flex align-items-center gap-2 mb-0 policy--listing">
          <li class="fs-14 fw-400">
            <a href="{{env.websiteUrl}}privacy-policy" target="_blank">Privacy Policy</a>
          </li>
          <li>•</li>
          <li class="fs-14 fw-400">
            <a href="{{env.websiteUrl}}terms-and-conditions" target="_blank"> Terms & Conditions</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="min-image-handel-card left-card-wrapper d-none  p-0">
    <div class="login-left--wrapper">
      <div class="image-div">
        <img class="main-image" src="assets/images/img/main-image.png" alt="login register">
      </div>
      <!-- <img src="assets/images/img/backgound-main.png"> -->
      <div class="bottom-content">
        <div class="left d-flex gap-2 align-items-center">
          <img src="assets/images/img/call-icon.png">
          <p class="mb-0 fw-500 fs-16">Call us at <span>+1 (833) 904-7001</span></p>
        </div>
        <div class="right btn-group gap-3">
          <a class="fw-500 fs-16 btn btn-white" href="https://www.recuvery.com/demo-scheduler/" target="_blank">Book a
            Demo</a>
          <button class="fw-500 fs-16 btn btn-black d-none">
            <img src="assets/images/img/player-play-filled.png">
            <span>Watch Video</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>